import React from 'react';
import { Dropdown, Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import FeatherIcon from 'feather-icons-react';

interface LanguageSwitcherProps {
  className?: string;
}

interface Language {
  code: string;
  name: string;
  flag: string;
}

const LANGUAGES: Language[] = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
];

const LanguageSwitcher = ({ className }: LanguageSwitcherProps) => {
  const { i18n } = useTranslation();

  const currentLanguage = LANGUAGES.find(lang => lang.code === i18n.language) || LANGUAGES[0];

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
    localStorage.setItem('i18nextLng', languageCode);
  };

  const isActive = (code: string) => i18n.language === code;

  return (
    <Nav.Item className={classNames('language-switcher', className)}>
      <Dropdown autoClose="outside" className="h-100">
        <Dropdown.Toggle
          as={Link}
          to="#!"
          className="dropdown-caret-none nav-link h-100"
          variant=""
        >
          <div className="d-flex align-items-center">
            <span className="language-flag">{currentLanguage.flag}</span>
            <span className="language-code d-none d-sm-inline">
              {currentLanguage.code.toUpperCase()}
            </span>
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu align="end" className="language-dropdown">
          {LANGUAGES.map((language) => (
            <Dropdown.Item
              key={language.code}
              onClick={() => handleLanguageChange(language.code)}
              className={classNames('language-item', { active: isActive(language.code) })}
            >
              <span className="language-flag me-2">{language.flag}</span>
              <span className="language-name flex-grow-1">{language.name}</span>
              {isActive(language.code) && (
                <FeatherIcon icon="check" size={16} className="text-primary" />
              )}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </Nav.Item>
  );
};

export default LanguageSwitcher;
